import React, { Component } from "react";
import _ from "lodash";
import Journee from "./les-tabs/Journee";
import Identite from "./les-tabs/Identite";
import Planning from "./les-tabs/Planning";
import HistoEvent from "./les-tabs/HistoEvent";
import HistoSante from "./les-tabs/HistoSante";
import MessagerieFiche from "./les-tabs/MessagerieFiche";
import Aliments from "./les-tabs/Aliments";
import Notes from "./les-tabs/Notes";
import Documents from "./les-tabs/Documents";
import moment from "moment";
import { getJournee } from "./les-tabs-ducks/Journee.ducks";
import { fetchOneKid, fetchArchiveKid } from "../../Kids.ducks";
import { connect } from "react-redux";
import { toUpperCaseFirst } from "../../../../ReactConst";
import { NavLink, Switch, Route, Link, Redirect } from "react-router-dom";
import ModalEnfant from "../modals/modal-enfant";
import { Service } from "../../../service/service";
import { API } from "../../../../const";
import { AddButton } from "../../../../components";
import { withTranslation } from 'react-i18next';
function notEmpty(x) {
  return !_.isEmpty(x);
}

class FicheEnfant extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dateStartEnd: {},
      tabActive: "",
      lienPhoto: "",
      modalEnfant: false,
      submitMulti: false,
      dataMulti: {},
      tabToUpdate: "",
      isUpdate: false,
      idEvent: null,
      onlyView: false,
      isLoading: true,
      objAbsence: {},
      kid: {},
      kidArchive: {},
      modalNotifications: false,
      croppedPhoto: null,
      fromArchive: window.location.pathname.includes("archives"),
      urlOrdonance: [],
      traitementsList: [],
      medicalFolder: [],
    };
    this.toggleSimple = this.toggleSimple.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.toUpdateEvent = this.toUpdateEvent.bind(this);
    this.toViewEvent = this.toViewEvent.bind(this);
    this.stopUpdate = this.stopUpdate.bind(this);
    this.stopViewing = this.stopViewing.bind(this);
    this.editEnfant = this.editEnfant.bind(this);
    this.editAbscence = this.editAbscence.bind(this);
    this.onOpenModaleNotifications = this.onOpenModaleNotifications.bind(this);
    this.onCloseModaleNotifications = this.onCloseModaleNotifications.bind(
      this
    );
    this.showPhoto = this.showPhoto.bind(this);
  }

  showPhoto = (photo) => {
    this.setState({
      croppedPhoto: window.URL.createObjectURL(photo),
    });
  };

  UNSAFE_componentWillMount() {
    let id = window.location.pathname.match(/\d+/g)[0];
    let tok = localStorage.getItem("token");
    const response = Service.get(
      `${API}api/enfant/creche/enfants/${id}/dossier-medical/ordonnances`,
      { headers: { Authorization: `Bearer ${tok}` } }
    );
    response.then((res) => {
      if (!_.isEmpty(res.data)) {
        var ListUrls = [];
        ListUrls = res.data.ordonnances.map(function(element) {
          return element.urlOrdonnance;
        });
        this.setState({
          urlOrdonance: ListUrls,
        });
      }

      const response = Service.get(
        `${API}api/enfant/creche/enfants/${id}/dossier-medical/traitements`,
        { headers: { Authorization: `Bearer ${tok}` } }
      );
      response.then((res) => {
        if (!_.isEmpty(this.props.kid)) {
          this.setState({
            traitementsList: res.data.traitements,
          });
        }

        const response = Service.get(
          `${API}api/enfant/creche/enfants/${id}/dossier-medical`,
          { headers: { Authorization: `Bearer ${tok}` } }
        );
        response.then((res) => {
          this.setState({
            medicalFolder: res.data,
          });
        });
        response.catch((err) => {});
      });
      response.catch((err) => {});
    });
    response.catch((err) => {});

    let fromArchive = window.location.pathname.includes("archives");
    if (_.isEmpty(this.props.kid) && !fromArchive) {
      this.props.fetchOneKid(
        localStorage.getItem("token"),
        this.props.match.params.id
      );
    } else if (!fromArchive) {
      this.setState({
        lienPhoto: this.props.kid.lienPhoto,
        kid: this.props.kid,
      });
    }
    if (fromArchive) {
      this.props.fetchArchiveKid(
        localStorage.getItem("token"),
        this.props.match.params.id
      );
    }
  }
  componentDidUpdate(prevProps, prevState) {
    let fromArchive = window.location.pathname.includes("archives");
    if (prevProps.kid !== this.props.kid) {
      this.setState({
        lienPhoto: this.props.kid.lienPhoto,
        kid: this.props.kid,
      });
    }
    if (prevProps.kidArchive !== this.props.kidArchive) {
      this.setState({
        lienPhoto: this.props.kidArchive.enfant.lienPhoto,
        kid: this.props.kidArchive.enfant,
        kidArchive: this.props.kidArchive,
      });
    }
    if (
      prevProps.successMsg !== this.props.successMsg &&
      this.props.successMsg.status
    ) {
      this.handleClose();
    }

    if (prevState.croppedPhoto !== this.state.croppedPhoto) {
      this.setState({
        croppedPhoto: this.state.croppedPhoto,
      });
    } else if (
      this.state.croppedPhoto == null &&
      this.state.lienPhoto !== null
    ) {
      this.setState({
        croppedPhoto: this.state.lienPhoto,
      });
    } else {
    }
  }
  toggleSimple(name) {
    this.setState({
      showAlertSnackbars: true,
      isUpdate: false,
      objAbsence: {},
      modalEnfant: false,
    });
  }
  toViewEvent(tabToView, idEvent) {
    this.setState({
      onlyView: true,
      tabToView: tabToView,
      modalEnfant: true,
      idEvent: idEvent,
    });
  }
  toUpdateEvent(tabToUpdate, idEvent, objAbsence) {
    this.setState({
      isUpdate: true,
      tabToUpdate: tabToUpdate,
      modalEnfant: true,
      idEvent: idEvent,
      objAbsence: objAbsence,
    });
  }
  stopViewing() {
    this.setState({ onlyView: false });
  }
  stopUpdate() {
    this.setState({ isUpdate: false, objAbsence: {} });
  }
  handleClose() {
    this.setState({
      modalEnfant: false,
      submitMulti: false,
      isUpdate: false,
      idEvent: null,
      onlyView: false,
      tabActive: null,
      dateStartEnd: null,
    });
  }
  editEnfant() {
    this.setState({ modalEnfant: true });
  }
  editAbscence(dateStartEnd) {
    this.setState({
      tabActive: "absence-tab",
      modalEnfant: true,
      dateStartEnd: dateStartEnd,
    });
  }
  onOpenModaleNotifications() {
    this.setState({ modalNotifications: true });
  }
  onCloseModaleNotifications() {
    this.setState({ modalNotifications: false });
  }

  render() {
    let {
      errorByID,
      match,
      ficheEnfant: {
        Identite: { isArchived },
      },
    } = this.props;
    const { kid, kidArchive } = this.state;

    let fromArchive = window.location.pathname.includes("archives");

    return (
      <>
        <main className="main-wrapper fiche-enfant">
          <div className="banner d-flex justify-content-center">
            {fromArchive ? (
              <Link to={`/creche/archives`} className="back-link">
                {this.props.t('common.back')}
              </Link>
            ) : (
              <Link to="/" className="back-link">
                {this.props.t('common.back')}
              </Link>
            )}
            <div className="content">
              <div className="selected-child d-flex align-items-center">
                <div className="relative-pos">
                  <div
                    className="avatar-fiche"
                    style={{
                      backgroundImage: "url(" + kid.lienPhoto + ")",
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                    }}
                  ></div>
                  {!fromArchive && (
                    <a
                      style={{ cursor: "pointer" }}
                      className="round-add-btn d-flex align-items-center justify-content-center gradient round-add-btn-absolute-top-right"
                      onClick={this.editEnfant}
                    >
                      <AddButton onClick={this.editEnfant} />
                    </a>
                  )}
                </div>
                <h1>
                  {!_.isEmpty(kid)
                    ? toUpperCaseFirst(kid.prenom) +
                      " " +
                      toUpperCaseFirst(kid.nom)
                    : ""}
                  <small>
                    {fromArchive ? this.props.t('fiche_enfant_page.archived_since') : this.props.t('fiche_enfant_page.registered_since')}
                    {!fromArchive && !_.isEmpty(kid)
                      ? moment(kid.dateAcceptation).format("MMMM,YYYY")
                      : fromArchive && !_.isEmpty(kidArchive)
                      ? moment(kidArchive.dateArchivage).format("MMMM,YYYY")
                      : ""}
                  </small>
                </h1>
              </div>
            </div>
          </div>
          {errorByID ? <Redirect to="/enfants" /> : ""}
          <section className="content-fiche">
            <ul
              className="nav nav-tabs choices-elts d-flex align-items-center justify-content-between"
              id="myTab"
              role="tablist"
            >
              {!fromArchive && (
                <li className="nav-item">
                  <NavLink
                    activeClassName="active"
                    className="nav-link choice journee"
                    id="journee-tab"
                    data-toggle="tab"
                    to={match.url + "/journee"}
                    role="tab"
                    aria-controls="home"
                    aria-selected="true"
                  >
                    <span>{this.props.t('fiche_enfant_page.tab_journee')}</span>
                  </NavLink>
                </li>
              )}
              <li className="nav-item">
                <NavLink
                  activeClassName="active"
                  className="nav-link choice identite"
                  id="identite-tab"
                  data-toggle="tab"
                  to={match.url + "/identite"}
                  role="tab"
                  aria-controls="profile"
                  aria-selected="false"
                >
                  <span>{this.props.t('fiche_enfant.tab_identity')}</span>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  activeClassName="active"
                  className="nav-link choice historique-medical"
                  id="historique-medical-tab"
                  data-toggle="tab"
                  to={match.url + "/historique-medical"}
                  role="tab"
                  aria-controls="contact"
                  aria-selected="false"
                >
                  <span>{this.props.t('fiche_enfant.tab_health')}</span>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  activeClassName="active"
                  className="nav-link choice aliments"
                  id="aliments-tab"
                  data-toggle="tab"
                  to={match.url + "/aliments"}
                  role="tab"
                  aria-controls="profile"
                  aria-selected="false"
                >
                  <span>{this.props.t('fiche_enfant.tab_aliments')}</span>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  activeClassName="active"
                  className="nav-link choice planning"
                  id="planning-tab"
                  data-toggle="tab"
                  to={match.url + "/planning"}
                  role="tab"
                  aria-controls="contact"
                  aria-selected="false"
                >
                  <span>{this.props.t('fiche_enfant.tab_planning')}</span>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  activeClassName="active"
                  className="nav-link choice historique-evenements"
                  id="historique-evenements-tab"
                  data-toggle="tab"
                  to={match.url + "/historique-evenements"}
                  role="tab"
                  aria-controls="profile"
                  aria-selected="false"
                >
                  <span>{this.props.t('fiche_enfant_page.tab_histo_events')}</span>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  activeClassName="active"
                  className="nav-link choice message"
                  id="messagerie-fiche-tab"
                  data-toggle="tab"
                  to={match.url + "/messages"}
                  role="tab"
                  aria-controls="contact"
                  aria-selected="false"
                >
                  <span>{this.props.t('fiche_enfant.tab_messages')}</span>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  activeClassName="active"
                  className="nav-link choice notes"
                  id="notes-tab"
                  data-toggle="tab"
                  to={match.url + "/notes"}
                  role="tab"
                  aria-controls="notes"
                  aria-selected="false"
                >
                  <span>{this.props.t('fiche_enfant.tab_notes')}</span>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  activeClassName="active"
                  className="nav-link choice documents"
                  id="documents-tab"
                  data-toggle="tab"
                  to={match.url + "/documents"}
                  role="tab"
                  aria-controls="documents"
                  aria-selected="false"
                >
                  <span>{this.props.t('fiche_enfant.tab_documents')}</span>
                </NavLink>
              </li>
            </ul>
            <div className="tab-content p-0" id="myTabContent">
              <Switch>
                {kid && !fromArchive && (
                  <Route
                    path={`${match.url}/journee`}
                    render={(props) => (
                      <Journee
                        dataJournee={this.props.ficheEnfant.Journee.data}
                        loadingJournee={this.props.ficheEnfant.Journee.loading}
                        kidItem={kid}
                        toUpdateEvent={this.toUpdateEvent}
                        onOpenModaleNotifications={
                          this.onOpenModaleNotifications
                        }
                        onCloseModaleNotifications={
                          this.onCloseModaleNotifications
                        }
                        modalNotifications={this.state.modalNotifications}
                        {...props}
                      />
                    )}
                  ></Route>
                )}
                {isArchived && !fromArchive ? (
                  <Redirect to="/" />
                ) : isArchived && fromArchive ? (
                  <Redirect to="/enfants" />
                ) : (
                  ""
                )}
                <Route
                  path={`${match.url}/identite`}
                  render={(props) => (
                    <Identite
                      kidItem={kid}
                      kidArchive={kidArchive}
                      {...props}
                      showPhoto={this.showPhoto}
                    />
                  )}
                ></Route>
                <Route
                  path={`${match.url}/historique-medical`}
                  render={(props) => (
                    <HistoSante
                      values={this.state}
                      fromArchive={fromArchive}
                      {...props}
                    />
                  )}
                ></Route>
                <Route
                  path={`${match.url}/aliments`}
                  render={(props) => <Aliments kidItem={kid} {...props} />}
                ></Route>
                <Route
                  path={`${match.url}/planning`}
                  render={(props) => (
                    <Planning
                      dataPlanning={this.props.ficheEnfant.Planning.data}
                      kidItem={kid}
                      toUpdateEvent={this.toUpdateEvent}
                      editAbscence={this.editAbscence}
                      {...props}
                    />
                  )}
                ></Route>
                <Route
                  path={`${match.url}/historique-evenements`}
                  render={(props) => (
                    <HistoEvent
                      kidItem={kid}
                      toViewEvent={this.toViewEvent}
                      {...props}
                    />
                  )}
                ></Route>
                <Route
                  path={`${match.url}/messages`}
                  render={(props) => (
                    <MessagerieFiche kidItem={kid} {...props} />
                  )}
                ></Route>
                <Route
                  path={`${match.url}/notes`}
                  render={(props) => (
                    <Notes kidItem={kid} {...props} />
                  )}
                ></Route>
                <Route
                  path={`${match.url}/documents`}
                  render={(props) => (
                    <Documents kidItem={kid} {...props} />
                  )}
                ></Route>
              </Switch>
            </div>
          </section>
        </main>
        {this.state.modalEnfant && (
          <ModalEnfant
            dataMulti={this.state.dataMulti}
            submitMulti={this.state.submitMulti}
            isOpen={this.state.modalEnfant}
            handleClose={this.handleClose}
            toggle={this.toggleSimple}
            kidItem={kid}
            tabToUpdate={this.state.tabToUpdate}
            isUpdate={this.state.isUpdate}
            tabToView={this.state.tabToView}
            onlyView={this.state.onlyView}
            stopUpdate={this.stopUpdate}
            stopViewing={this.stopViewing}
            modals={this.props.modals}
            idEvent={this.state.idEvent}
            objAbsence={this.state.objAbsence}
            dateStartEnd={this.state.dateStartEnd}
            tabActive={this.state.tabActive}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  ficheEnfant: state.ficheEnfant,
  journee: state.ficheEnfant.Journee,
  kid: state.kids.byId[ownProps.match.params.id],
  modals: state.modals,
  successMsg: state.successMsg,
  kidArchive: state.kids.byIdArchive[ownProps.match.params.id],
  errorByID: state.kids.errorByID,
});

export default connect(mapStateToProps, {
getJournee,
  fetchOneKid,
  fetchArchiveKid,
})(withTranslation()(FicheEnfant));
